import passportImage from "../assets/gigs/valencia-passport.svg";
import fabricaImage from "../assets/gigs/standup-comedy-valencia.jpg";
import guirisImage from "../assets/gigs/guiris-con-ganas.jpg";
import catacomImage from "../assets/gigs/the-vlc-playground.webp";
import streetLevelImage from "../assets/gigs/streetlevelcomedy.png";
import comedyExchangeImage from "../assets/gigs/comedyexchange.png";
import karaokeKomedyImage from "../assets/gigs/karaoke-komedy-piano-bar-lupin.jpg";
import karaokeKomedy480 from "../assets/gigs/karaoke-komedy-piano-bar-lupin-480.webp";
import karaokeKomedy900 from "../assets/gigs/karaoke-komedy-piano-bar-lupin-900.webp";
import saturdayNiteMistakesImage from "../assets/gigs/saturday-nite-mistakes-valencia.jpg";
import saturdayNiteMistakes480 from "../assets/gigs/saturday-nite-mistakes-valencia-480.webp";
import saturdayNiteMistakes900 from "../assets/gigs/saturday-nite-mistakes-valencia-900.webp";
import goalSpainFootballImage from "../assets/gigs/goal-spain-football-comedy.jpg";
import hahaLolWeenImage from "../assets/gigs/haha-lol-ween-valencia.jpg";

export const valenciaPassport = {
  id: "valencia-comedy-passport",
  passportId: "valencia-comedy-passport",
  title: "Valencia Comedy Passport",
  city: "Valencia",
  county: "Valencia",
  country: "Spain",
  languages: ["English", "Spanish"],
  requiredStampCount: 3,
  status: "early_access",
  image: passportImage,
  imageUrl: passportImage,
  description:
    "Discover independent Valencia comedy shows, collect venue stamps, and unlock audience rewards.",
};

export const valenciaGigs = [
  {
    id: "fabrica-de-hielo",
    gigId: "fabrica-de-hielo",
    passportId: valenciaPassport.id,
    title: "Class Clowns Reunion",
    venueName: "La Fabrica de Hielo",
    addressLine1: "Carrer de Pavia, 37",
    addressLine2: "Poblats Maritims",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "46011",
    location: { lat: 39.4699, lng: -0.3248 },
    language: "English",
    dateLabel: "September 29",
    startAt: "2026-09-29T20:00:00+02:00",
    endAt: "2026-09-29T22:00:00+02:00",
    timezone: "Europe/Madrid",
    capacity: 12,
    image: fabricaImage,
    imageUrl: fabricaImage,
    ownerUid: "",
    ownerDisplayName: "",
    managerName: "Alexey",
    status: "completed",
    passportStatus: "participating",
    category: "comedy",
    ticketingModel: "unknown",
    claimToken: "vcp_7vQmD4xK9nR2sW6cH8jL3pT5",
    description:
      "Back-to-school stories, old memories, and a live English-language comedy night at La Fabrica de Hielo.",
  },
  {
    id: "karaoke-komedy-lupin",
    gigId: "karaoke-komedy-lupin",
    passportId: valenciaPassport.id,
    title: "Karaoke Komedy",
    venueName: "Piano Bar Lupin",
    addressLine1: "Mercado Colon, lower level",
    addressLine2: "Carrer de Jorge Juan, 19",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "46004",
    location: { lat: 39.46889, lng: -0.36823 },
    language: "English",
    dateLabel: "October 14",
    doorsAt: "2026-10-14T19:30:00+02:00",
    startAt: "2026-10-14T20:30:00+02:00",
    endAt: "2026-10-14T22:30:00+02:00",
    timezone: "Europe/Madrid",
    capacity: null,
    priceText: "EUR 5 with one beer, or EUR 10 with two beers or one copa",
    externalUrl: "https://www.fourvenues.com/piano-bar-lupin/MXKD",
    image: karaokeKomedyImage,
    imageUrl: karaokeKomedyImage,
    imageSrcSet: `${karaokeKomedy480} 480w, ${karaokeKomedy900} 900w, ${karaokeKomedyImage} 1254w`,
    ownerUid: "",
    ownerDisplayName: "Yoti",
    managerName: "Yoti",
    status: "scheduled",
    passportStatus: "participating",
    category: "comedy",
    ticketingModel: "ticketed",
    claimToken: "vcp_K14pL8xN4qR7mT2yC9wF6sH3",
    description:
      "Karaoke meets live comedy at Piano Bar Lupin, with an international Valencia crowd and drinks included in the ticket options.",
  },
  {
    id: "saturday-nite-mistakes-valencia",
    gigId: "saturday-nite-mistakes-valencia",
    passportId: valenciaPassport.id,
    title: "Saturday Nite Mistakes Valencia",
    venueName: "La Vitti",
    addressLine1: "Placa del Xuquer, 3",
    addressLine2: "",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "46021",
    location: { lat: 39.4751, lng: -0.3534 },
    language: "English",
    ageRestriction: "18+",
    dateLabel: "October 17",
    doorsAt: "2026-10-17T20:00:00+02:00",
    startAt: "2026-10-17T20:30:00+02:00",
    endAt: "2026-10-17T22:00:00+02:00",
    timezone: "Europe/Madrid",
    capacity: null,
    priceText: "See Eventbrite for current ticket options",
    externalUrl: "https://www.eventbrite.com/e/1999629818616?aff=oddtdtcreator",
    image: saturdayNiteMistakesImage,
    imageUrl: saturdayNiteMistakesImage,
    imageSrcSet: `${saturdayNiteMistakes480} 480w, ${saturdayNiteMistakes900} 900w, ${saturdayNiteMistakesImage} 1024w`,
    ownerUid: "",
    ownerDisplayName: "Yoti",
    managerName: "Yoti",
    status: "scheduled",
    passportStatus: "participating",
    category: "comedy",
    ticketingModel: "ticketed",
    claimToken: "vcp_S17vM5qD8rT2kN6xP4cH9wL7",
    description:
      "Saturday-night stand-up in English at La Vitti: new city, same mistakes, and a sharp international lineup.",
  },
  {
    id: "goal-spain-football-comedy",
    gigId: "goal-spain-football-comedy",
    passportId: valenciaPassport.id,
    title: "GOAL! Why Spain Owns Football",
    venueName: "Espai Llimera",
    addressLine1: "Carrer de Timoneda, 6",
    addressLine2: "Extramurs",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "46008",
    language: "English",
    dateLabel: "October 15",
    startAt: "2026-10-15T20:00:00+02:00",
    endAt: "2026-10-15T21:30:00+02:00",
    timezone: "Europe/Madrid",
    capacity: 50,
    priceText: "EUR 10",
    externalUrl: "https://www.meetup.com/valencia-walks-talks/events/316850597/",
    image: goalSpainFootballImage,
    imageUrl: goalSpainFootballImage,
    ownerUid: "",
    ownerDisplayName: "Alexey",
    managerName: "Alexey",
    status: "scheduled",
    passportStatus: "participating",
    category: "comedy",
    ticketingModel: "ticketed",
    claimToken: "vcp_G15fB8xQ2mN6tR4yK9cL7sW3",
    description:
      "Alexey Timbul mixes stand-up, Spanish football history, and playful investigation into one sharp live comedy show.",
  },
  {
    id: "haha-lol-ween-valencia",
    gigId: "haha-lol-ween-valencia",
    passportId: valenciaPassport.id,
    title: "HAHA-LOL-WEEN Comedy Show",
    venueName: "La Fabrica de Hielo",
    addressLine1: "Carrer de Pavia, 37",
    addressLine2: "Poblats Maritims",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "46011",
    language: "English",
    dateLabel: "October 27",
    startAt: "2026-10-27T20:00:00+01:00",
    endAt: "2026-10-27T21:30:00+01:00",
    timezone: "Europe/Madrid",
    capacity: 75,
    priceText: "EUR 10 early bird or EUR 13 standard",
    externalUrl: "https://www.meetup.com/valencia-walks-talks/events/316900545/",
    image: hahaLolWeenImage,
    imageUrl: hahaLolWeenImage,
    ownerUid: "",
    ownerDisplayName: "Alexey",
    managerName: "Alexey",
    status: "scheduled",
    passportStatus: "participating",
    category: "comedy",
    ticketingModel: "ticketed",
    claimToken: "vcp_H27aL6xQ9mT3rN8yC4wK2sP5",
    description:
      "A Halloween stand-up special at La Fabrica de Hielo, hosted by Alexey Timbul for Valencia's international comedy crowd.",
  },
  {
    id: "guiris-con-ganas",
    gigId: "guiris-con-ganas",
    passportId: valenciaPassport.id,
    title: "Guiris Con Ganas",
    venueName: "Guiris Con Ganas",
    addressLine1: "Valencia",
    addressLine2: "",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "",
    location: { lat: 39.4699, lng: -0.3763 },
    language: "English",
    dateLabel: "July 9",
    startAt: "2026-07-09T20:00:00+02:00",
    endAt: "2026-07-09T22:00:00+02:00",
    timezone: "Europe/Madrid",
    capacity: 10,
    image: guirisImage,
    imageUrl: guirisImage,
    ownerUid: "",
    ownerDisplayName: "",
    status: "completed",
    passportStatus: "guide",
    description:
      "A welcoming independent comedy night with a lively international audience.",
  },
  {
    id: "catacom",
    gigId: "catacom",
    passportId: valenciaPassport.id,
    title: "CataCom",
    venueName: "CataCom",
    addressLine1: "Valencia",
    addressLine2: "",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "",
    location: { lat: 39.4699, lng: -0.3763 },
    language: "English",
    dateLabel: "August 6",
    startAt: "2026-08-06T20:00:00+02:00",
    endAt: "2026-08-06T22:00:00+02:00",
    timezone: "Europe/Madrid",
    capacity: 10,
    image: catacomImage,
    imageUrl: catacomImage,
    ownerUid: "",
    ownerDisplayName: "",
    status: "completed",
    passportStatus: "guide",
    description:
      "An intimate Valencia comedy room built around close-up crowd connection.",
  },
  {
    id: "street-level-comedy-night",
    gigId: "street-level-comedy-night",
    passportId: valenciaPassport.id,
    title: "Street Level Comedy Night",
    venueName: "Street Level Comedy Night",
    addressLine1: "Valencia",
    addressLine2: "",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "",
    location: { lat: 39.4699, lng: -0.3763 },
    language: "English",
    dateLabel: "September 10",
    startAt: "2026-09-10T20:00:00+02:00",
    endAt: "2026-09-10T22:00:00+02:00",
    timezone: "Europe/Madrid",
    capacity: 10,
    image: streetLevelImage,
    imageUrl: streetLevelImage,
    ownerUid: "",
    ownerDisplayName: "",
    status: "completed",
    passportStatus: "guide",
    description:
      "A direct, lively comedy night with close-up room energy.",
  },
  {
    id: "comedy-exchange",
    gigId: "comedy-exchange",
    passportId: valenciaPassport.id,
    title: "Comedy Exchange",
    venueName: "Comedy Exchange",
    addressLine1: "Valencia",
    addressLine2: "",
    city: "Valencia",
    county: "Valencia",
    country: "Spain",
    postcode: "",
    location: { lat: 39.4699, lng: -0.3763 },
    language: "English / Spanish",
    dateLabel: "June 16",
    startAt: "2026-06-16T20:00:00+02:00",
    endAt: "2026-06-16T22:00:00+02:00",
    timezone: "Europe/Madrid",
    capacity: 12,
    image: comedyExchangeImage,
    imageUrl: comedyExchangeImage,
    ownerUid: "",
    ownerDisplayName: "",
    status: "completed",
    passportStatus: "guide",
    description:
      "A bilingual stand-up comedy show for audiences in English and Spanish.",
  },
];

export const getGigById = (gigId) =>
  valenciaGigs.find((gig) => gig.id === gigId) || valenciaGigs[0];

export const findGigById = (gigId) =>
  valenciaGigs.find((gig) => gig.id === gigId);

export const findGigBySlug = (showSlug) =>
  findGigById(showSlug === "class-clowns-reunion" ? "fabrica-de-hielo" : showSlug);

export const findGigByClaimToken = (claimToken) =>
  valenciaGigs.find((gig) => gig.claimToken === claimToken);

export const getShowDetailsPath = (show) =>
  show?.id === "fabrica-de-hielo"
    ? "/shows/class-clowns-reunion"
    : `/shows/${show?.id || ""}`;

export const pilotShow = valenciaGigs[0];
export const pilotShowClaimToken = "vcp_7vQmD4xK9nR2sW6cH8jL3pT5";

export const isPassportShow = (show) => show?.passportStatus === "participating";

export const participatingShows = valenciaGigs.filter(isPassportShow);

export const isPastShow = (show, now = Date.now()) => {
  const lifecycleAt = new Date(show?.endAt || show?.startAt || 0).getTime();
  return Number.isFinite(lifecycleAt) && lifecycleAt < Number(now);
};

export const partitionValenciaGigs = (shows, now = Date.now()) => ({
  upcoming: shows.filter((show) => !isPastShow(show, now)),
  past: shows.filter((show) => isPastShow(show, now)),
});

export const sortValenciaGigs = (shows, now = Date.now()) => [...shows].sort((left, right) => {
  const leftUpcoming = !isPastShow(left, now);
  const rightUpcoming = !isPastShow(right, now);
  if (leftUpcoming !== rightUpcoming) return leftUpcoming ? -1 : 1;
  return leftUpcoming
    ? new Date(left.startAt).getTime() - new Date(right.startAt).getTime()
    : new Date(right.startAt).getTime() - new Date(left.startAt).getTime();
});

export const orderedValenciaGigs = sortValenciaGigs(valenciaGigs);

export const getAudienceShowDateLabel = (show, now = Date.now()) => {
  if (!show?.startAt) return "Next date coming soon";
  const dateLabel = show.dateLabel || new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    timeZone: show.timezone || "Europe/Madrid",
  }).format(new Date(show.startAt));
  return !isPastShow(show, now)
    ? dateLabel
    : `Completed · ${dateLabel}`;
};

const GIGATHLON_BOOKING_WHATSAPP = "447739343143";

export const hasDirectBookingUrl = (show) => {
  if (!show?.externalUrl) return false;
  try {
    const url = new URL(show.externalUrl);
    const host = url.hostname.replace(/^www\./, "");
    return url.protocol === "https:"
      && host !== "wa.me"
      && host !== "api.whatsapp.com"
      && host !== "whatsapp.com";
  } catch (_error) {
    return false;
  }
};

export const getShowBookingAction = (show) => {
  if (hasDirectBookingUrl(show)) {
    return { href: show.externalUrl, label: "Book tickets", method: "booking_link" };
  }

  const message = [
    `Hi, I found ${show?.title || "this show"} on the Valencia Comedy Passport by Gigathlon.`,
    `I'd like to book tickets${show?.dateLabel ? ` for ${show.dateLabel}` : ""}${show?.venueName ? ` at ${show.venueName}` : ""}.`,
    "Please send me the booking details.",
  ].join(" ");

  return {
    href: `https://wa.me/${GIGATHLON_BOOKING_WHATSAPP}?text=${encodeURIComponent(message)}`,
    label: "Book via WhatsApp",
    method: "whatsapp",
  };
};
